import { render } from "./gsrbr0404.vue?vue&type=template&id=1635dd10&scoped=true"
import script from "./gsrbr0404.vue?vue&type=script&lang=js"
export * from "./gsrbr0404.vue?vue&type=script&lang=js"

import "./gsrbr0404.vue?vue&type=style&index=0&id=1635dd10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1635dd10"]])

export default __exports__